// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__opQJy","input":"index_input__lONo_","suffix":"index_suffix__XmqKw"};